import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import { useQuery } from 'react-query';
import { useMatches } from 'react-router-dom';
import { GetNetworkSearchContext } from '../../data/apiCalls';
import ashlinkLogo from '../../assets/ASHlink_Logo_Dark.svg';

const Header = () => {
	const matches = useMatches();
	const healthplanCode = matches.find(m => m.params.healthplanCode)?.params
		.healthplanCode;

	const clientDetails = useQuery(
		['networkSearchContext', healthplanCode],
		() => GetNetworkSearchContext(healthplanCode),
		{
			enabled: !!healthplanCode,
			staleTime: Infinity,
			refetchOnWindowFocus: false,
			retry: false,
		}
	);

	const logo = clientDetails.data?.data?.logo;
	const hasCobrandedLogo = !!logo;

	return (
		<AppBar
			position='static'
			elevation={0}
			sx={{
				minHeight: 64,
				display: 'flex',
				justifyContent: 'center',
				backgroundColor: 'background.default',
			}}
		>
			<Stack direction='row' spacing={4}>
				<img
					style={{ marginLeft: '48px' }}
					src={ashlinkLogo}
					alt='ASHLink Logo'
					width='128px'
				/>

				{healthplanCode && hasCobrandedLogo && (
					<img
						src={`data:image/png;base64,${logo}`}
						alt='Cobranded Logo'
						style={{
							maxHeight: '48px',
							maxWidth: '200px',
							objectFit: 'contain',
						}}
					/>
				)}
			</Stack>
		</AppBar>
	);
};

export default Header;
